export default __webpack_public_path__ + "static/media/heart-lock.b8172296.png";